import "./index.css";
import { AppRouter } from "./app/AppRouter";
import { AuthProvider } from "./lib/auth";
import { AppPreferencesProvider } from "./lib/preferences";
import { ProviderOfflineProvider } from "./lib/provider-offline";

export function App() {
  return (
    <AppPreferencesProvider>
      <ProviderOfflineProvider>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </ProviderOfflineProvider>
    </AppPreferencesProvider>
  );
}

export default App;
